export default __webpack_public_path__ + "static/media/fondo4.a8b39227.jpg";